import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take, debounce } from 'rxjs/operators';
import { AppAuthNService } from '../services/app-auth-n.service';
import { debug } from 'util';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(public authn: AppAuthNService,
    private router: Router,
  ) { }

  public canActivate(){
    if(localStorage.getItem("access_token")){
      return true;
    }else{
      return false;
    }
  }
}
